import axios from "axios";

const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();
const API = (backendUrl && backendUrl !== "http://localhost:8000") ? `${backendUrl.replace(/\/$/, "")}/api` : "/api";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
